<template>
  <b-card>
    <b-card-body>
      <div class="overflow-x-auto">
        <ul :class="items().length > 3 ? 'columns' : ''">
          <li v-for="i in items()" :key="`column-${i.key}`">
            <b-form-checkbox :id="i.key" :checked="i.active" @change="updateColumn(i)">
              {{ i.label }}
            </b-form-checkbox>
          </li>
        </ul>
      </div>
    </b-card-body>
  </b-card>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { IConfColumnaPais, IPais, ISoConfConlumnasPaisUpdate } from "@/entities";
import { Action } from "vuex-class";
import Pagination from "@/components/common/Pagination.vue";
import VueFilters from "@/vue-filters";

import SelectColumns from "@/components/common/SelectColumns/SelectColumns.vue";
import { IColumnaResponse } from "@/services";
import PFormSwitch from "@/components/look/PFormCheckBox/PFormSwitch.vue";

@Component({
  components: { PFormSwitch, SelectColumns, Pagination },
  mixins: [VueFilters],
})
export default class ColumnasTable extends Vue {
  @Prop({ required: true, default: null }) config!: IConfColumnaPais[];
  @Watch("config", { deep: true })
  onChangeParams(): void {
    this.columnasVisibles = [];

    const columnas: IConfColumnaPais[] = JSON.parse(JSON.stringify(this.config));
    if (columnas.length) {
      columnas.forEach((col: IConfColumnaPais) => {
        if (col.visible) {
          this.columnasVisibles.push(col.codColumna);
        }
      });
    }
  }
  @Prop({ required: false, default: null }) country!: IPais;
  @Prop({ required: false, default: null }) table!: string;

  @Action("saveColumnaConfPais") saveColumnaConfPais!: (
    params: ISoConfConlumnasPaisUpdate
  ) => Promise<IColumnaResponse | undefined>;

  private columnasVisibles: string[] = [];

  private items(): { key: string; label?: string; active: boolean }[] {
    const items: { key: string; label?: string; active: boolean }[] = [];

    if (this.config) {
      this.config.forEach((columna: IConfColumnaPais) => {
        items.push({
          key: columna.codColumna,
          label: this.$t("label." + columna.codColumna),
          active: columna.visible,
        });
      });
    }
    return items;
  }

  async updateColumn(item: { key: string; label: string; active: string }): Promise<void> {
    let index = this.columnasVisibles.indexOf(item.key);
    if (index >= 0) {
      this.columnasVisibles.splice(index, 1);
    } else {
      this.columnasVisibles.push(item.key);
    }
    const rest = await this.saveColumnaConfPais({
      codPaisCorto: this.country?.codPaisCorto,
      codTabla: this.table,
      codColumna: this.columnasVisibles.join(","),
    });
    if (rest) {
      this.$emit("update");
    }
  }
}
</script>
<style lang="scss" scoped>
.table-cell-middle {
  word-break: keep-all;
}

.table-header {
  text-transform: uppercase;
}

.table-cell {
  white-space: nowrap;
}

ul {
  list-style: none; /* Remove default bullets */
  margin-bottom: 10px;
}

ul button {
  background-color: var(--amarillo-prosegur);
  border: solid var(--amarillo-prosegur);
  text-align: center;
}

ul.columns {
  @media (min-width: 992px) {
    columns: 4;
    -webkit-columns: 4;
    -moz-columns: 4;
  }
}
</style>
